module.exports = __webpack_public_path__ + "img/nature-29.4d3c5895.jpg";